import { Editor } from 'react-draft-wysiwyg';
import React, { useEffect, useState } from 'react';
import { Grid, Card, Button } from '@mui/material';
import {
  ContentState,
  EditorState,
} from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import htmlToDraft from 'html-to-draftjs';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { customOptions } from '../../../../Common/TextEditorOptions';
import {
  getUnitPriceJobOrderStart, jobOrderClientSiteForm, setJobOrderComments, setSelectedTab, updateJobOrderStart,
} from '../../redux/sliceJobOrder';
import { ANALYST_NOTE_TAB } from '../../utils/constants';
import { RootState } from '../../../../redux/rootState';
import { formatJobOrderPayload } from '../../utils/helper';
import EndPoints from '../../../../Routes/EndPoints';
import {
  setDisplayVessels, setDropDownVessels, setNumberOfTubes, setTubeLength,
} from '../../../Job/ScreenUnitInformation/redux/unitInfoSlice';
import { MasterData } from '../../../../utils/type';
import { stripCustPrefix } from '../../../../utils/CommonFunctions';
import { assignVesselData, formatvesselData } from '../../../Job/ScreenUnitInformation/utils/helper';
import { VesselData } from '../../../Job/ScreenUnitInformation/utils/type';
import { vesselOrder } from '../../../../utils/Constant';

function ScreenComments() {
  const [comment, setComment] = useState(EditorState.createEmpty());
  const {
    numberOfTubes, tubeLength, displayVesselsAfter, machineType, vesselMaster, displayVessels, selectedUnit,
  } = useSelector((state: RootState) => state.unitInfoReducer);
  const {
    jobOrderComment, Comments, AnalystNoteData, mainFormData, clientSiteFormData, ClientData, SiteData,
    UnitId, AnalystId, unitPriceJobOrder, VesselsInfoData, IsJobCompleted, JobOrderMainData,
  } = useSelector((state: RootState) => state?.jobOrderReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    SerialNo,
  } = useSelector((state: RootState) => state.unitInfoReducer);

  const handleComment = (newEditorState: EditorState) => {
    setComment(newEditorState);
    dispatch(setJobOrderComments(newEditorState));
  };
  const htmlToEditorState = (html: string): EditorState => {
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
      return EditorState.createWithContent(contentState);
    }
    return EditorState.createEmpty();
  };

  const getHtmlFromEditorHTMLtoString = (newEditorState: EditorState): string => {
    const contentState = newEditorState.getCurrentContent();
    return stateToHTML(contentState);
  };

  useEffect(() => {
    const jobOrderCommentText = jobOrderComment.getCurrentContent().getPlainText();
    if (jobOrderCommentText?.length > 0) {
      const convertedComment = jobOrderComment;
      setComment(convertedComment);
    } else if (Comments) {
      const convertedComment = htmlToEditorState(Comments);
      setComment(convertedComment);
    }
  }, [Comments, jobOrderComment]);

  const [newVesselData, setNewVesselData] = useState<VesselData[]>([]);

  useEffect(() => {
    if (displayVesselsAfter.length >= displayVessels.length) {
      setNewVesselData(displayVesselsAfter);
    } else {
      setNewVesselData(displayVessels);
    }
  }, [displayVessels]);

  useEffect(() => {
    if (vesselMaster.length > 0 && newVesselData.length === 0 && !selectedUnit?.UnitId) {
      const val = formatvesselData(vesselMaster);
      const displayData: VesselData[] = [];
      const dropDownData: VesselData[] = [];

      val.forEach((vessel: VesselData) => {
        if (vessel.vesselType.toLowerCase() === 'other') {
          return;
        }
        if (vessel.display) {
          displayData.push(vessel);
        } else {
          dropDownData.push(vessel);
        }
      });
      const reorderedData = displayData.sort(
        (a, b) => vesselOrder.indexOf(a?.vesselName) - vesselOrder.indexOf(b?.vesselName),
      );
      dispatch(setDisplayVessels(reorderedData));
      dispatch(setDropDownVessels(dropDownData));
    }
  }, [vesselMaster]);

  useEffect(() => {
    if (UnitId && VesselsInfoData.VesselIds.length > 0 && vesselMaster.length > 0) {
      const val = assignVesselData(VesselsInfoData?.VesselIds, vesselMaster);
      const displayData: VesselData[] = [];
      const dropDownData: VesselData[] = [];

      val.forEach((vessel: VesselData) => {
        if (vessel.display) {
          displayData.push(vessel);
        } else if (vessel.vesselType.toLowerCase() !== 'other') {
          dropDownData.push(vessel);
        }
      });
      const orderedData = [...displayData]?.sort((a, b) => {
        const indexA = vesselOrder.indexOf(a.vesselName);
        const indexB = vesselOrder.indexOf(b.vesselName);

        const rankA = indexA === -1 ? Number.MAX_SAFE_INTEGER : indexA;
        const rankB = indexB === -1 ? Number.MAX_SAFE_INTEGER : indexB;

        return rankA - rankB;
      });
      dispatch(setDisplayVessels(orderedData));
      dispatch(setDropDownVessels(dropDownData));
      // Calculate Total Number and Max Tube
      const allVessels = [...VesselsInfoData.VesselIds, ...VesselsInfoData.OtherVessels];
      if (displayVesselsAfter.length >= allVessels.length) {
        const totalNumberOfTubes = displayVesselsAfter?.reduce((sum, vessel) => sum + vessel.numberOfTube, 0);
        dispatch(setNumberOfTubes(totalNumberOfTubes));
      } else {
        const totalNumberOfTubes = allVessels?.reduce((sum, vessel) => sum + vessel.NumberOfTubes, 0);
        dispatch(setNumberOfTubes(totalNumberOfTubes));
      }
      const maxTubeLength = Math.max(...allVessels.map((vessel) => vessel.TubeLength));
      dispatch(setTubeLength(maxTubeLength));
    }
  }, [VesselsInfoData, UnitId, vesselMaster]);

  useEffect(() => {
    if (UnitId) {
      const machine = machineType?.find((ele: MasterData) => ele.Value === String(mainFormData?.machineType));
      const payload = {
        TestType: mainFormData?.testType || '0',
        MachineType: machine?.Text || '',
        TotalTubeQty: numberOfTubes || 0,
        TubeLength: tubeLength || 0,
        OD: Number(mainFormData?.odTubes) || 0,
        SpotTest: mainFormData?.spotTest,
        SafetyCharge: mainFormData?.safetyClass,
        SpotTestPercentage: Number(mainFormData?.pct) || 0,
      };
      dispatch(getUnitPriceJobOrderStart(payload));
    }
  }, [numberOfTubes, tubeLength]);

  useEffect(() => {
    const clientSitePayload = {
      SiteContact: SiteData?.Contact || '',
      clientAddress: ClientData?.Address || '',
      clientCity: ClientData?.CityName || '',
      clientContact: ClientData?.Contact || '',
      clientId: stripCustPrefix(ClientData?.CustomerId) || '',
      clientName: ClientData?.CustomerName || '',
      clientOptionalAddress: ClientData?.OptionalAddress || '',
      clientPhone: ClientData?.Phone || '',
      clientPhoneCode: ClientData?.PhoneCode || '',
      clientState: ClientData?.StateName || '',
      clientZip: ClientData?.Pincode || '',
      siteAddress: SiteData?.Address || '',
      siteCell: SiteData?.Cell || '',
      siteCity: SiteData?.CityName || '',
      siteCounty: SiteData?.SiteCountry || '',
      siteId: SiteData?.SiteId || '',
      siteName: SiteData?.SiteName || '',
      sitePhone: SiteData?.Phone || '',
      siteOptionalAddress: SiteData?.OptionalAddress || '',
      sitePhoneCode: SiteData?.PhoneCode || '',
      siteState: SiteData?.StateName || '',
      siteZip: SiteData?.Pincode || '',
    };
    dispatch(jobOrderClientSiteForm(clientSitePayload));
  }, []);

  const handleSave = () => {
    const newComment = getHtmlFromEditorHTMLtoString(comment);
    const payload = formatJobOrderPayload(
      UnitId,
      AnalystId,
      VesselsInfoData,
      mainFormData,
      clientSiteFormData,
      displayVesselsAfter,
      unitPriceJobOrder,
      numberOfTubes,
      tubeLength,
      AnalystNoteData,
      newComment,
      SerialNo,
      JobOrderMainData?.IsMigrated || false,
    );
    dispatch(updateJobOrderStart({ payload, navigate }));
  };

  const handleChangeTab = () => {
    dispatch(setSelectedTab(ANALYST_NOTE_TAB));
  };

  return (
    <div className="div_container_CustomerInfo">
      <Grid container spacing={2}>
        <Grid item md={12} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item md={12} sm={12} xs={12}>
              <Card className="comment-card">
                <div className="customerInfo_container">
                  <div className="customerInfo">
                    Comment
                  </div>
                </div>
                <div className="customerInfo_main_container">
                  <Grid container spacing={2}>
                    <Grid item md={12} sm={12} xs={12}>
                      <div className="editorContainer">
                        <Editor
                          editorState={comment}
                          onEditorStateChange={handleComment}
                          wrapperClassName="demo-wrapper"
                          editorClassName="demo-editor"
                          localization={{ locale: 'en' }}
                          toolbar={customOptions}
                          readOnly={!IsJobCompleted}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <div className="save_and_next_div">
            <div>
              <Button className="button_cancel" onClick={handleChangeTab}>Back</Button>
            </div>
            <div className="button_margin_left">
              {IsJobCompleted
                ? <Button className="button_save_and_next" onClick={handleSave}>Save</Button>
                : <Button className="button_cancel" onClick={() => navigate(`/${EndPoints.JOB_ORDER}`)}>Cancel</Button>}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default ScreenComments;
